import { IconPlayerSetting } from '../../../../icons';
import { PlayerControlButton, SettingPanelItem, SettingWrapper } from '../../styles';
import Panel from '../../styles/Panel';
import { VideoJsPlayer } from 'video.js';
import { useEffect, useRef, useState } from 'react';
import ControlBarAudioPanel from './ControlBarAudioPanel';
import IconAutoplay from '../../../../icons/IconAutoplay';
import { settingControllerKey } from '../../PlayerModels';
import ControlBarCaptionPanel from './ControlBarCaptionPanel';
import PlaybackRateSelector from './ControlBarPlayBackRate';
import ControlBarQualityLevelPanel from './ControlBarQualityLevelPanel';
import UsePlayerProps from '../../../../Store/usePlayerProps';
import theme from '../../../../theme';
import lscache from 'lscache';

const Setting = ({ player, showCaptions, showQualities, changeCaptionPosition, emitActivePanel }: {
  player: VideoJsPlayer;
  showCaptions: boolean;
  showQualities: boolean;
  changeCaptionPosition: boolean;
  emitActivePanel: (status: boolean) => void;
}) => {
  const playerGlobalState = UsePlayerProps((state) => state.playerState);
  const setPlayerGlobalState = UsePlayerProps((state) => state.setPlayerState);
  const { contentConfigs, contentData, sources } = playerGlobalState;
  const [isOpen, setIsOpen] = useState(false);
  // const [playerTech, setPlayerTech] = useState<'hls' | 'mp4'>('hls');
  const [autoNextEpisode, setAutoNextEpisode] = useState<boolean>(true);
  const [activeSetting, setActiveSetting] = useState<settingControllerKey>(null);
  const contentType = contentData?.content?.type;
  const [isMobile, setIsMobile] = useState(false);

  const resizeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    if (window) {
      const config = lscache.get('player_config');
      if (config) {
        // setPlayerTech(config.tech);
        setAutoNextEpisode(config.autoNextEpisode);
      }
      handleMobileBreakpoint();
      throttledHandle();
      window.addEventListener('resize', throttledHandle, { passive: true });
    }
    return () => {
      window.removeEventListener('resize', throttledHandle);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
        resizeTimerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const throttledHandle = () => {
    if (resizeTimerRef.current !== null) return;
    resizeTimerRef.current = setTimeout(() => {
      handleMobileBreakpoint();
      resizeTimerRef.current = null;
    }, 100);
  };

  useEffect(() => {
    emitActivePanel(isOpen);
    setActiveSetting(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const handleMobileBreakpoint = () => {
    setIsMobile(Number(theme.breakpoints.md) > Number(window.innerWidth));
  };

  // const handlePlayerTechChange = () => {
  //   lscache.set('player_config', { ...lscache.get('player_config'), tech: playerTech === 'hls' ? 'mp4' : 'hls' });
  //   setPlayerTech(playerTech === 'hls' ? 'mp4' : 'hls');
  //   window.location.reload();
  // };

  const handleSetAutoNextEpisode = () => {
    lscache.set('player_config', { autoNextEpisode: !autoNextEpisode });
    setPlayerGlobalState({
      ...playerGlobalState,
      showingNextEpisode: !autoNextEpisode,
    });
    setAutoNextEpisode(!autoNextEpisode);
  };

  return (
    <>
      <PlayerControlButton
        size="semiLarge"
        icon={<IconPlayerSetting />}
        active={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        mr={isMobile ? 0.5 : 1.5}
      />
      <Panel horizontalPos={{ right: '1.5rem' }} onClose={() => setIsOpen(false)} show={isOpen} customPadding={{ default: '1rem 0', responsive: '0.5rem 0' }}>
        <SettingWrapper>
          {!activeSetting && contentConfigs?.playback_type !== 'live_stream' && (
            <>
              {/* {!contentConfigs?.url?.includes('gp00') && <SettingPanelItem*/}
              {/*  icon={<IconPlayerTech />}*/}
              {/*  label={'player.play_simple'}*/}
              {/*  onClick={handlePlayerTechChange}*/}
              {/*  checked={playerTech === 'mp4'}*/}
              {/* />}*/}
              {contentType && contentType === 'episode' && contentConfigs?.next_episode && (
                <SettingPanelItem
                  icon={<IconAutoplay />}
                  label={'player.auto_nex_episode'}
                  onClick={handleSetAutoNextEpisode}
                  checked={autoNextEpisode}
                />
              )}
            </>
          )}
          {player.audioTracks().length > 1 && (
            <ControlBarAudioPanel
              activeSetting={activeSetting}
              player={player}
              handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
            />
          )}

          {showCaptions && (
            <ControlBarCaptionPanel
              activeSetting={activeSetting}
              player={player}
              handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
              changePosition={changeCaptionPosition}
              showCaptions={showCaptions}
            />
          )}
          <PlaybackRateSelector
            activeSetting={activeSetting}
            player={player}
            handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
          />
          {showQualities && sources?.videos.length && (
            <ControlBarQualityLevelPanel
              activeSetting={activeSetting}
              player={player}
              handleSettingItemClick={(controllerKey: settingControllerKey) => setActiveSetting(controllerKey)}
            />
          )}
        </SettingWrapper>
      </Panel>
    </>
  );
};

export default Setting;
